import React from 'react';
import { ListingObjects } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSuccessful && nextProps.savedObject) {
      this.props.api.routing.redirect(this.props.router, `/email/property-datas/${nextProps.savedObject.id}`);
    }
  }
  render() {
    return (
      <ListingObjects
        { ...this.props }
        deleteMessage="Are you sure you want to delete the data for this property?"
      />
    );
  }
}

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'email_property_datas',
  namespace: 'emailPropertyData',
  mountedUrl: '/email/property-datas',
  title: 'Datas for properties',
  columns: [
    { attribute: 'name', label: 'property' },
    { label: 'defined', sortable: false, value: (object) => !!object.email_data.value[1] ? <i className="fas fa-check" /> : null },
  ],
  canCreate: false,
  canDelete: (object) => !!object.email_data.value[1],
  onEdit: (object, props) => {
    if (!object.email_data.value[1]) {
      const objectData = {
        id: 0,
        property: { $type: 'reference', external: true, value: ['properties', object.id] },
      };
      props.api.emailPropertyData.submitCreateForm(objectData);
    } else {
      props.api.routing.redirect(props.router, `/email/property-datas/${object.email_data.value[1]}`);
    }
  },
  onDelete: (object, props) => {
    props.api.emailPropertyData.deleteObject(object.email_data.value[1]);
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/containers/Listing.jsx